import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	default: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.dropdown.default-value.default',
		defaultMessage: 'Default',
		description: 'Label. Displayed if option selected as default value.',
	},
	disabledDefaultTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.dropdown.default-value.disabled-default-tooltip',
		defaultMessage: 'You can’t clear the default option',
		description: "Tooltip shown when a user can't clear the default value of an option",
	},
	setAsDefault: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.dropdown.default-value.set-as-default',
		defaultMessage: 'Set as default',
		description:
			'Label for button. Allows user to mark option as default value for a dropdown field',
	},
	clearDefault: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.dropdown.default-value.clear-default',
		defaultMessage: 'Clear default',
		description:
			'Label for button. Allows user to remove "default option" mark from an option of a dropdown field',
	},
});
